import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// MARK://dhk8/ui/components/Dialog
// Port de sc-restaurant Dialog.tsx — portal a body, Escape, role=dialog aria-modal.
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
export function Dialog({ open, onClose, title, children, footer, closeOnOverlay = true, }) {
    useEffect(() => {
        if (!open)
            return;
        const onKey = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, onClose]);
    if (!open || typeof document === 'undefined')
        return null;
    return createPortal(_jsx("div", { className: "dhk8-dialog-overlay", onClick: closeOnOverlay ? onClose : undefined, role: "presentation", children: _jsxs("div", { className: "dhk8-dialog", onClick: (e) => e.stopPropagation(), role: "dialog", "aria-modal": "true", "aria-labelledby": title ? 'dhk8-dialog-title' : undefined, children: [title !== undefined && (_jsxs("div", { className: "dhk8-dialog__header", children: [_jsx("h2", { className: "dhk8-dialog__title", id: "dhk8-dialog-title", children: title }), _jsx("button", { type: "button", className: "dhk8-btn dhk8-btn--ghost dhk8-btn--sm dhk8-btn--icon", onClick: onClose, "aria-label": "Cerrar", children: _jsx(X, { size: 16 }) })] })), _jsx("div", { className: "dhk8-dialog__body", children: children }), footer !== undefined && _jsx("div", { className: "dhk8-dialog__footer", children: footer })] }) }), document.body);
}
//# sourceMappingURL=Dialog.js.map